import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { wrapIntoObservable } from 'ng-zorro-antd/core/util';
import { Observable, share, tap } from 'rxjs';
import { environment } from '@environments/environment';

import { resolveAssetFixture, resolveAssetIcon } from './assets.helper';

@Injectable({ providedIn: 'root' })
export class AssetsService {
  private http = inject(HttpClient);

  private cache: Map<string, Observable<string> | string> = new Map();

  getIcon(name: string) {
    const cached = this.cache.get(name);
    if (cached) {
      return wrapIntoObservable(cached);
    }

    const req = this.http
      .get(resolveAssetIcon(name), {
        headers: {
          'content-type': 'image/svg+xml',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          Authorization: `Basic ${environment.authToken}`,
        },
        observe: 'body',
        responseType: 'text',
      })
      .pipe(share());

    this.cache.set(name, req);

    return req.pipe(tap((response) => this.cache.set(name, response)));
  }

  getFixture<Response>(name: string) {
    return this.http.get<Response>(resolveAssetFixture(name), {
      headers: {
        'content-type': 'application/json',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Authorization: `Basic ${environment.authToken}`,
      },
      observe: 'body',
    });
  }
}
